<ds-form-field style="width: 100px">
  <ds-select
    id="currentUserCountry"
    [labellingConfig]="{
      placeholder: translateService.instant('dashboard.header.country'),
    }"
    [ngModel]="currentUserActiveCountry()"
    [options]="currentUserCountryOptions() | selectListSort"
    [size]="size()"
    (valueChange)="onCurrentUserCountryChange($event)"
  >
  </ds-select>
</ds-form-field>
